import { render, staticRenderFns } from "./scretDictionaryDetailModal.vue?vue&type=template&id=315e2c8c&scoped=true"
import script from "./scretDictionaryDetailModal.vue?vue&type=script&lang=js"
export * from "./scretDictionaryDetailModal.vue?vue&type=script&lang=js"
import style0 from "./scretDictionaryDetailModal.vue?vue&type=style&index=0&id=315e2c8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e2c8c",
  null
  
)

export default component.exports